import { action, observable, makeObservable } from 'mobx';

import type { UserProfileData } from 'chaika-frontend-types/frontend-cms';
import { Locale } from 'chaika-enums';

import { Form, InitParams, ValidationType } from '@store/abstract/Form';

import { UserProfile } from './UserProfile';

export class UserForm extends Form {
    protected storeName = 'profile';

    @observable
    protected profile: UserProfile = new UserProfile();

    constructor() {
        super();
        makeObservable(this);

        this.init();
    }

    public get id(): string {
        return this.profile.id;
    }

    public serialize(): UserProfileData {
        return this.profile.serialize();
    }

    @action
    public setProfile(userData: UserProfileData = {} as UserProfileData) {
        this.profile = new UserProfile(userData);
        this.profile.setProfileData(userData);
    }

    public setFieldTranslations(fieldName: string, value: string, lang: Locale) {
        this.profile.setTranslations(fieldName, value, lang);
    }

    protected getInitParams(): InitParams[] {
        return [
            {
                name: 'firstName',
                isRequired: true,
                validation: [ValidationType.notEmpty, ValidationType.Name],
            },
            {
                name: 'lastName',
                isRequired: true,
                validation: [ValidationType.notEmpty, ValidationType.Name],
            },
            {
                name: 'oldLastName',
                validation: ValidationType.Name,
            },
            {
                name: 'patronymic',
                validation: ValidationType.Name,
            },
            {
                name: 'accountFirstName',
                isRequired: true,
                validation: [ValidationType.notEmpty, ValidationType.Name],
            },
            {
                name: 'accountLastName',
                isRequired: true,
                validation: [ValidationType.notEmpty, ValidationType.Name],
            },
            {
                name: 'accountPatronymic',
                validation: ValidationType.Name,
            },
            {
                name: 'engFirstName',
                isRequired: true,
                validation: [ValidationType.NameEng],
            },
            {
                name: 'engLastName',
                isRequired: true,
                validation: [ValidationType.NameEng],
            },
            {
                name: 'engOldLastName',
                validation: ValidationType.NameEng,
            },
            {
                name: 'engPatronymic',
                validation: ValidationType.NameEng,
            },
            {
                name: 'roles',
            },
            {
                name: 'canBeEpisodeManager',
            },
            {
                name: 'avatar',
                validation: ValidationType.Url,
            },
            {
                name: 'profileUrl',
                validation: ValidationType.Url,
            },
            {
                name: 'avatarUnits',
                validation: ValidationType.AvatarUnits,
            },
            {
                name: 'phone',
                validation: ValidationType.PhoneString,
            },
            {
                name: 'email',
                isRequired: true,
                validation: [ValidationType.notEmpty, ValidationType.Email],
            },
            {
                name: 'telegram',
                validation: ValidationType.Nickname,
            },
            {
                name: 'skype',
                validation: ValidationType.Nickname,
            },
            {
                name: 'startOfCareer',
                validation: [ValidationType.Date],
            },
            {
                name: 'degrees',
            },
            {
                name: 'introductory',
            },
            {
                name: 'education',
            },
            {
                name: 'experience',
            },
            {
                name: 'publications',
            },
            {
                name: 'reasonForWork',
            },
            {
                name: 'languages',
                validation: ValidationType.StringArray,
            },
            {
                name: 'snils',
                validation: ValidationType.Snils,
            },
        ];
    }
}
